import { render } from "./Banner.vue?vue&type=template&id=fa99ff28&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=fa99ff28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa99ff28"

export default script